import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { SvcCommentsModule } from '@solvace/feature/general/svc-comments/svc-comments.module';
import { LibSharedCommonModule } from 'projects/lib-shared-common/src/public-api';
import { StaticApplicationId } from 'projects/lib-shared-core/src/lib/Constants/static-application-id.enum';
import { SvcCommentsChatComponent } from '../../../../../general/svc-comments/components/svc-comments-chat/svc-comments-chat.component';

@Component({
    selector: 'svc-action-plan-feed-tab',
    standalone: true,
    imports: [CommonModule, TranslocoModule, LibSharedCommonModule, SvcCommentsModule],
    templateUrl: './svc-action-plan-feed-tab.component.html',
    styleUrls: ['./svc-action-plan-feed-tab.component.scss'],
})
export class SvcActionPlanFeedTabComponent {
    @ViewChild(SvcCommentsChatComponent) public svcCommentsChat?: SvcCommentsChatComponent;

    @Input() public actionPlanId: number | null = null;
    @Output() public commentsTotalChange = new EventEmitter<number>();
    @Output() public commentsChanged = new EventEmitter<void>();

    public readonly actionPlanCommentConfigTypeId = 'A59245C1-7D4E-4B3A-9F2C-1E8D7C6B5A40';
    public readonly actionPlanApplicationId = StaticApplicationId.actionPlanRevamp;

    public onCommentsTotalChange(total: number): void {
        this.commentsTotalChange.emit(total);
    }

    public onCommentsChanged(): void {
        this.commentsChanged.emit();
    }
}
